import React, { Component, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation, withTranslation } from "react-i18next";
import { withFormik, Form } from "formik";
import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import { FormRow, SelectRow } from "../Form/Form";
import { stationsLookup } from "../../utils/UFLstationsEnum";
import axios from "axios";
import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import { validateEmail50, validateSomething } from "../Form/Validations";
import CeresImg from "../../img/external/ceresImg.png";
import floridaImg from "../../img/external/floridaImg.png";
import zentracloudImg from "../../img/external/zentracloudImg.png";
import arableImg from "../../img/external/arableImg.png";
import weenatImg from "../../img/external/weenatImg.png";
import irrimaxImg from "../../img/external/irrimaxImg.png";
import davisImg from "../../img/external/davisImg.png";
import LoadingDialog from "../Utils/LoadingDialog";
import { dateFormat } from "../../utils/date";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FarmContext } from "../../contexts/FarmContext";
import { IrrimaxFormikForm } from "./Forms/Irrimax";
import { DavisFormikForm } from "./Forms/DavisConfigForm";
import { DavisLoginDialog } from "./Forms/DavisLoginDialog";

import { Dialog } from "primereact/dialog";
import DropdownPrime from "../PrimeComponents/DropdownPrime";
import { Divider } from "primereact/divider";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";

const STEP_CONNECT = 0;
const STEP_USER = 1;
const STEP_INFO = 2;
const STEP_ZONE = 3;

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const external_form = "external_form";

//createInput
const FormExternalsMaker = ({ type1, edit, nombre1, campo1, eyeForPassword = false }) => {
    return <FormRow
        type1={type1}
        edit={edit}
        nombre1={nombre1}
        campo1={campo1}
        eyeForPassword={eyeForPassword}
        key={campo1}
    />;
};

const GetExternalForm = ({ externalType, t }) => {

    switch (externalType) {
        case "CERES":
        case "ARABLE": {
            const usernameForm = {
                edit: true,
                nombre1: t("external.username"),
                campo1: "username",
            };
            const passwordForm = {
                type1: "password",
                edit: true,
                nombre1: t("external.password"),
                campo1: "password",
                eyeForPassword: true,
            };

            return [usernameForm, passwordForm].map((e) => FormExternalsMaker(e));
        }
        case "WEENAT": {
            const emailForm = {
                edit: true,
                nombre1: t("personal.email"),
                campo1: "email",
            };
            const passForm = {
                type1: "password",
                edit: true,
                nombre1: t("external.password"),
                campo1: "password",
                eyeForPassword: true,
            };

            return [emailForm, passForm].map((e) => FormExternalsMaker(e));
        }
        case "UFL": {
            const stations = Object.keys(stationsLookup);
            const stationsObj = stations.map((name) => {
                return { nombre: name, id: stationsLookup[name], texto: name };
            });

            const select = (
                <SelectRow
                    edit
                    nombre={t("external.selectStation")}
                    campo="stationId"
                    options={stationsObj}
                    optionKey="id"
                    optionLabel="nombre"
                    placeholder={t("external.selectStation")}
                />
            );

            return select;
        }
        case "ZENTRACLOUD": {
            const deviceSnForm = {
                edit: true,
                nombre1: t("external.serial-number"),
                campo1: "deviceSn",
            };
            const apiKeyForm = {
                edit: true,
                nombre1: t("external.api-token"),
                campo1: "apiToken",
            };

            return [deviceSnForm, apiKeyForm].map((e) => FormExternalsMaker(e));
        }
        case "IRRIMAX": {
            const apikeyIrrimax = {
                edit: true,
                nombre1: "API Key",
                campo1: "apiKey",
            };

            return [apikeyIrrimax].map((e) => FormExternalsMaker(e));
        }
        case "DAVIS": {
            const apiKeyDavis = {
                edit: true,
                nombre1: "API Key",
                campo1: "apiKey",
            };
            const secretKeyDavis = {
                edit: true,
                nombre1: "Secret Key",
                campo1: "secretKey",
            };
            return [apiKeyDavis, secretKeyDavis].map((e) => FormExternalsMaker(e));
        }
        default:
            break;
    }
};
class externalForm extends Component {
    render() {
        const { status = {}, canEdit, data, t, handleSubmit, values } = this.props;
        if (!data) return null;

        const forms = GetExternalForm({ externalType: data.tipo, t });
        return (
            <div>
                <div>
                    <Form id={external_form} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-12 text-center'>
                                {forms}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}



const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);
        return data;
    },
    enableReinitialize: true,
})(withTranslation()(externalForm));

const FormDialog = ({ formState, setFormState, setContador, dataCheck, setMainDialogState }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const farmId = getFarm(location);
    const formikRef = useRef(false);
    const [dataApi, setDataApi] = useState({ visible: false });
    const [showValidation, setShowValidation] = useState({ msg: "", visible: true });
    const [forceLoading, setForceLoading] = useState(false);
    const tipoCapitalized = formikRef?.current?.values?.tipo;
    const buttons = [
        {
            buttonModel: {
                cssClass: "e-primary",
                content: formikRef?.current?.values?.tipo === "CERES" ? t("external.login") : t("external.next"),
                isPrimary: true,
            },
            click: async () => {
                switch (formikRef?.current?.values?.tipo) {
                    case "CERES":
                        ceresConnection();
                        break;

                    case "UFL":
                        validateUFL();
                        break;
                    case "ZENTRACLOUD":
                        validateZentraCloud();
                        break;

                    case "ARABLE":
                        validateArable();
                        break;

                    case "WEENAT":
                        await validateWeenat();
                        break;

                    case "IRRIMAX":
                        await validateIrrimax();
                        break;

                    case "DAVIS":
                        await validateDavis();
                        break;

                    default:
                        break;
                }

            }
        },
        {
            buttonModel: {
                cssClass: "nonde",
                content: t("external.!login"),
                isPrimary: false,
            },
            click: () => {
                setShowValidation({ msg: "", visible: false });
                setFormState({ visible: false });
            }
        }
    ];

    // Manage Ceres Connection
    const ceresConnection = () => {
        if (formikRef?.current?.values?.username && formikRef?.current?.values?.password) {
            const errorEmail = validateEmail50(formikRef?.current?.values?.username);
            if (errorEmail !== undefined) {
                setShowValidation({ msg: t("external.not-email"), visible: true });
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            } else {
                const getAccessRefreshToken = async () => {
                    const body = {
                        "username": formikRef?.current?.values?.username,
                        "password": formikRef?.current?.values?.password
                    };
                    const { data } = await axios.post("https://works.ceresimaging.net/api/token/", body);
                    return data;
                };
                const response = getAccessRefreshToken();
                response.then((res) => {
                    if (res?.access) {
                        setShowValidation(false);
                        setDataApi({
                            dataToken: res,
                            dataUser: formikRef?.current?.values?.username,
                            dataTipo: formikRef?.current?.values?.tipo,
                            visible: true,
                            step:STEP_USER
                        });
                        setFormState({ data: formState?.data, visible: false });
                        formikRef.current.values.username = "";
                        formikRef.current.values.password = "";
                    }
                }).catch((e) => {
                    setShowValidation({ msg: t("external.error-sign-in"), visible: true });
                    console.error(e);
                    setFormState({
                        headerText: formState.headerText,
                        data: formState?.data,
                        visible: true
                    });
                });
            }
        } else {
            setShowValidation({ msg: t("external.user-pass"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };
    const validateUFL = () => {
        if (formikRef?.current?.values?.stationId) {
            setShowValidation(false);
            setDataApi({

                stationId: formikRef?.current?.values?.stationId,
                dataTipo: formikRef?.current?.values?.tipo,
                visible: true
            });

            setFormState({ data: formState?.data, visible: false });
        } else {
            setShowValidation({ msg: t("external.not-all-fields"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true,
                step:STEP_USER
            });
        }
    };

    const validateZentraCloud = () => {
        if (formikRef?.current?.values?.apiToken && formikRef?.current?.values?.deviceSn) {
            const isValidToken = async () => {
                const param = `/external/${farmId}`;
                const body = { validate: true, apiToken: formikRef?.current?.values?.apiToken, deviceSn: formikRef?.current?.values?.deviceSn };
                await RestAPI.post("apiAdminDropControl", param, { body });
            };
            const response = isValidToken();
            response.then((res) => {
                setShowValidation(false);
                setDataApi({
                    deviceSn: formikRef?.current?.values?.deviceSn,
                    apiToken: formikRef?.current?.values?.apiToken,
                    dataTipo: formikRef?.current?.values?.tipo,
                    visible: true,
                    step:STEP_USER
                });
                setFormState({ data: formState?.data, visible: false });

            }).catch((e) => {
                setShowValidation({ msg: t("external.error-verify-in"), visible: true });
                console.error(e);
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            });

        } else {
            setShowValidation({ msg: t("external.not-all-fields"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };

    const validateArable = () => {
        if (formikRef?.current?.values?.username && formikRef?.current?.values?.password) {
            const errorEmail = validateEmail50(formikRef?.current?.values?.username);
            if (errorEmail !== undefined) {
                setShowValidation({ msg: t("external.not-email"), visible: true });
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            } else {
                const getAccessRefreshToken = async () => {
                    const endpoint = `/external/${farmId}/arable-credentials`;
                    const body = {
                        "arableEmail": formikRef?.current?.values?.username,
                        "arablePassword": formikRef?.current?.values?.password
                    };
                    const data = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                    return data;
                };
                const response = getAccessRefreshToken();
                response.then((res) => {
                    setShowValidation(false);
                    setDataApi({
                        dataToken: res, // OK
                        dataUser: formikRef?.current?.values?.username,
                        dataTipo: formikRef?.current?.values?.tipo,
                        apiKey: res?.apiKey,
                        devices: res?.devices,
                        visible: true,
                        step:STEP_USER
                    });
                    setFormState({ data: formState?.data, visible: false });
                    formikRef.current.values.username = "";
                    formikRef.current.values.password = "";
                }).catch((e) => {
                    setShowValidation({ msg: t("external.error-sign-in"), visible: true });
                    console.error(e);
                    setFormState({
                        headerText: formState.headerText,
                        data: formState?.data,
                        visible: true
                    });
                });
            }
        } else {
            setShowValidation({ msg: t("external.user-pass"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };

    const validateWeenat = async () => {
        if (formikRef?.current?.values?.email && formikRef?.current?.values?.password) {
            // validate fields
            const errorEmail = validateEmail50(formikRef?.current?.values?.email);
            if (errorEmail) {
                setShowValidation({ msg: t("external.not-email"), visible: true });
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
                return;
            }
            try {
                const endpoint = `/external/${farmId}/weenat-credentials`;
                const body = {
                    "email": formikRef?.current?.values?.email,
                    "password": formikRef?.current?.values?.password
                };
                const resWeenatData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                const weenatData = resWeenatData.data;
                setShowValidation(false);
                setDataApi({
                    dataTipo: formikRef?.current?.values?.tipo,
                    visible: true,
                    // state related to weenat case
                    token: weenatData.token,
                    plots: weenatData.plots,
                    organizations: weenatData.organizations,
                    step:STEP_USER
                });
                setFormState({ data: formState?.data, visible: false });
                formikRef.current.values.email = "";
                formikRef.current.values.password = "";
            } catch (error) {
                if (error.response?.status === 401){
                    setShowValidation({ msg: t("forms.toast401"), visible: true });
                } else {
                    setShowValidation({ msg: t("external.error-sign-in"), visible: true });
                }
                console.error(error);
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            }
        } else {
            setShowValidation({ msg: t("external.user-pass"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };

    const validateIrrimax = async () => {
        if (formikRef?.current?.values?.apiKey) {
            const errorApiKey = validateSomething(formikRef.current.values.apiKey.trim());
            if (errorApiKey) {
                setShowValidation({ msg: t(errorApiKey), visible: true });
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
                return;
            }
            setForceLoading(true);
            try {
                const endpoint = `/external/${farmId}/irrimax-credentials`;
                const body = {
                    "apiKey": formikRef?.current?.values?.apiKey,
                    "locale": i18n.language
                };
                const irrimaxData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                setShowValidation(false);
                setDataApi({
                    dataTipo: formikRef?.current?.values?.tipo,
                    visible: true,
                    // state related to irrimax case
                    apiKey: formikRef.current.values.apiKey,
                    supportedLoggers: irrimaxData.supportedLoggers,
                    unsupportedLoggers: irrimaxData.unsupportedLoggers,
                    step:STEP_USER
                });
                setFormState({ data: formState?.data, visible: false });
                formikRef.current.values.apiKey = "";
            } catch (error) {
                if (error.response?.status === 401){
                    setShowValidation({ msg: t("forms.toast401"), visible: true });
                } else {
                    setShowValidation({ msg: t("external.error-sign-in"), visible: true });
                }
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            }
            setForceLoading(false);
        } else {
            setShowValidation({ msg: t("validation.required"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };

    const validateDavis = async () => {
        const apiKey = formikRef?.current?.values?.apiKey?.trim();
        const secretKey = formikRef?.current?.values?.secretKey?.trim();
        if (apiKey && secretKey) {
            setForceLoading(true);
            try {
                const endpoint = `/external/${farmId}/davis-credentials`;
                const body = { apiKey, secretKey, locale: i18n.language };
                const davisData = await RestAPI.post("apiAdminDropControl", endpoint, { body });
                setShowValidation(false);
                setDataApi({
                    dataTipo: formikRef?.current?.values?.tipo,
                    visible: true,
                    // state related to davis case
                    apiKey,
                    secretKey,
                    davisStations: davisData.stations,
                    sensorTypes: davisData.sensorTypes,
                    step:STEP_USER
                });
                formikRef.current.values.apiKey = "";
                formikRef.current.values.secretKey = "";
                setFormState({ data: formState?.data, visible: false });
            } catch (error) {
                if (error.response?.status === 401){
                    setShowValidation({ msg: t("forms.toast401"), visible: true });
                } else {
                    setShowValidation({ msg: t("external.error-sign-in"), visible: true });
                }
                setFormState({
                    headerText: formState.headerText,
                    data: formState?.data,
                    visible: true
                });
            }
            setForceLoading(false);
        } else {
            setShowValidation({ msg: t("validation.required"), visible: true });
            setFormState({
                headerText: formState.headerText,
                data: formState?.data,
                visible: true
            });
        }
    };

    useEffect(() => {
        setShowValidation({ msg: "", visible: false });
    }, [formState?.visible]);
    return (
        <div>
            <DialogComponentWrapper
                formikRef={formikRef}
                containerId="external-form"
                t={t}
                dialogState={formState}
                setDialogState={setFormState}
                buttons={buttons}
                header={formState.headerText}
            >
                {forceLoading && <LoadingDialog extraClasses="fixMaxHeight" targetId="external_form" /> }
                <FormikForm
                    innerRef={formikRef}
                    canEdit
                    edit
                    data={formState.data}
                />
                {showValidation?.visible &&
                    <div className="col-12 msgRawValidation">
                        <span>{showValidation?.msg}</span>
                    </div>}
                <div>
                    {formikRef?.current?.values?.tipo === "CERES" ? t("external.msgAdv") : ""}
                    {formikRef?.current?.values?.tipo === "CERES" ? `${tipoCapitalized?.charAt(0).toUpperCase() + tipoCapitalized?.slice(1).toLowerCase()} Imaging` : ""}
                    {formikRef?.current?.values?.tipo === "ARABLE" ? t("external.msgAdv") : ""}
                    {formikRef?.current?.values?.tipo === "ARABLE" ? `${tipoCapitalized?.charAt(0).toUpperCase() + tipoCapitalized?.slice(1).toLowerCase()}` : ""}
                </div>
            </DialogComponentWrapper>
            <UserDialog dialogState={dataApi} setDialogState={setDataApi} setContador={setContador} dataCheck={dataCheck} setMainDialogState={setMainDialogState} setFormState={setFormState} />
        </div>
    );
};

const ConnectDialog = ({ dialogState, setDialogState, setContador, dataCheck,externalAllowed }) => {
    const { t, i18n } = useTranslation();
    const [formState, setFormState] = useState({ visible: false });
    const tipoCapitalized = dialogState?.selected?.tipo;
    const buttons = [
        {
            buttonModel: {
                cssClass: "e-primary",
                content: t("external.next"),
                isPrimary: true
            },
            click: () => {
                conectar();
            }
        }
    ];

    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );

    const conectar = () => {
        if (dialogState?.selected?.tipo) {
            const formattedType = tipoCapitalized?.charAt(0).toUpperCase() + tipoCapitalized?.slice(1).toLowerCase();
            const headerText = ["ARABLE", "CERES"].includes(dialogState?.selected?.tipo)
                ? t("external.sign-ext") + `${formattedType}`
                : t("external.connect-with") + " " + formattedType;
            setFormState({
                headerText: headerText,
                data: dialogState?.selected,
                visible: true
            });
            setDialogState((state) => {
                return { ...state, step: STEP_USER };
            });
        }
    };

    return (
        <div id='connectDialog'>
            <Dialog
                className='dialog-prime'
                visible={dialogState.visible}
                closable
                draggable={false}
                style={{width:"400px"}}
                baseZIndex={1040}
                footer={footerContent}
                onHide={() => setDialogState({visible:false})}
                header={t("external.header-external-provider")}
            >
                <div>
                    <FormDialog formState={formState} setFormState={setFormState} setContador={setContador} dataCheck={dataCheck} setMainDialogState={setDialogState} />
                </div>
                <div className='rowH5'>
                    <h5>{t("external.connect")}</h5>
                </div>
                <div className='rowH5'>
                    <div>
                        <DropdownPrime
                            id='ddlelement'
                            filter={false}
                            value={dialogState.selected}
                            onChange={(e) => {
                                setDialogState((state) => {
                                    return { ...state, selected: e?.value, step:STEP_USER};
                                });}}
                            options={dialogState?.data?.filter((e) =>externalAllowed.includes(e.tipo))} optionLabel="tipo"
                            placeholder={t("external.label-placeholder-externals")}
                            showClear={false}
                        />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

const InfoDialog = ({ dialogState, setDialogState, acceso_limitado, setContador, sectorsInfo }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const farmId = getFarm(location);
    const [ceresDataDdb, setCeresDataDdb] = useState([]);
    const [ceresFarmInfo, setCeresFarmInfo] = useState(null);
    const [groupedZones, setGroupedZones] = useState([]);
    const [soilZoneDialogState, setSoilZoneDialogState] = useState({ visible: false });
    const [davisLoginState, setDavisLoginState] = useState({ visible: false });
    const [_, dispatch] = useContext(FarmContext);
    const pumpsys = dispatch({ type: "get", path: "pumpsys" });

    const typeToImage = {
        "CERES": CeresImg,
        "UFL": floridaImg,
        "ZENTRACLOUD": zentracloudImg,
        "ARABLE": arableImg,
        "WEENAT": weenatImg,
        "IRRIMAX": irrimaxImg,
        "DAVIS": davisImg,
    };

    const ceresDeviceCache = useMemo(() => ({}), [farmId]);
    useEffect(() => {
        const uuid = dialogState?.dataUuid;

        if (uuid) {
            const cached = ceresDeviceCache[uuid];
            setCeresFarmInfo(cached?.farm ?? null);
            setCeresDataDdb(cached?.data ?? null);

            const param = `/external/${farmId}`;
            const body = { uuid };

            RestAPI.post("apiAdminDropControl", param, { body })
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res));
                    const farm = data?.Item?.farms?.find(f => f.campo_id == farmId);

                    ceresDeviceCache[uuid] = { data, farm };
                    setCeresFarmInfo(farm ?? null);
                    setCeresDataDdb(data);
                })
                .catch(err => console.error(err));
        } else {
            setCeresFarmInfo(null);
            setCeresDataDdb(null);
        }
    }, [farmId, ceresDeviceCache, dialogState?.dataUuid]);

    const hasSoilZone = useMemo(() => {
        return dialogState?.tipo_sector?.includes(2);
    }, [dialogState?.tipo_sector]);

    const irrigationZonesSelector = useMemo(() => {
        const irrigationSectors = sectorsInfo?.filter(sec => sec.tipo?.includes(3)) || [];
        pumpsys?.sort((a, b) => (a.equipo_orden < b.equipo_orden) ? -1 : 1);
        const result = [];
        if (Array.isArray(pumpsys)){
            for (const equipo of pumpsys){
                const sectoresEquipo = irrigationSectors.filter(s => s.equipo[0] === equipo.equipo_id);
                sectoresEquipo.sort((a, b) => {
                    if (a.orden !== b.orden) {
                        return a.orden - b.orden;
                    } else if (a.nombre_alternativo !== b.nombre_alternativo) {
                        if (!a.nombre_alternativo) return 1;
                        if (!b.nombre_alternativo) return -1;
                        return a.nombre_alternativo.localeCompare(b.nombre_alternativo);
                    } else {
                        return a.nombre.localeCompare(b.nombre);
                    }
                });
                for (const sector of sectoresEquipo){
                    result.push({
                        sector_id: sector.sector_id,
                        nombre: sector.nombre,
                        equipo: equipo.nombre
                    });
                }
            }
        }
        return result;
    }, [pumpsys, sectorsInfo]);


    const buttons = useMemo(() => {
        const showAlign = (dialogState?.type === "CERES" && Boolean(ceresFarmInfo?.flightDate) && !acceso_limitado);
        const showMigrateDavis = dialogState?.type === "DAVIS" && dialogState?.config?.version === 1;
        const additionalButtons = [];
        if (showMigrateDavis){
            additionalButtons.push({
                buttonModel: {
                    cssClass: "e-primary",
                    content: t("external.migrateToV2"),
                    isPrimary: false,
                    disabled: false
                },
                click: () => {
                    setDavisLoginState({
                        headerText: t("external.migrateToV2"),
                        data: {
                            tipo: "DAVIS"
                        },
                        visible: true,
                        nodoId: dialogState?.nodoId
                    });
                    setDialogState((state) => {
                        return { ...state, visible: false };
                    });
                }
            });
        }

        if (showAlign){
            additionalButtons.push({
                buttonModel: {
                    cssClass: "e-primary",
                    content: t("external.alinear_img"),
                    isPrimary: false,
                    disabled: !ceresFarmInfo?.flightDate || acceso_limitado
                },
                click: () => {
                    const newSearch = dialogState?.external_provider_id !== undefined ? `?farm=${farmId}&external=${dialogState?.external_provider_id}` : `?farm=${farmId}`;
                    navigate({ pathname: "/farms/imagealigner", search: newSearch },
                        { state: { expanded: [], updateTree: true } });
                }
            });
        }

        if (hasSoilZone && irrigationZonesSelector?.length > 0){
            const currentIrrZoneId = dialogState?.config?.sector_id_riego;
            additionalButtons.push({
                buttonModel: {
                    cssClass: "e-primary",
                    content: currentIrrZoneId ? t("external.editIrrigation") : t("external.associateIrrigation"),
                    isPrimary: false,
                    disabled: false
                },
                click: () => {
                    setDialogState({
                        visible: false
                    });
                    const _zones={
                        irrigationZones: currentIrrZoneId ?
                            [{sector_id: null, nombre: t("external.noAssociatedZone"), equipo: ""}, ...irrigationZonesSelector]
                            : irrigationZonesSelector,
                        providerZoneId: dialogState?.config?.sector_id,
                        currentIrrZoneId: currentIrrZoneId,
                        providerId: dialogState?.external_provider_id,
                        visible: true
                    };
                    setSoilZoneDialogState(_zones);
                    const zonesGrouped = _zones?.irrigationZones?.reduce((acc, nodo) => {
                        const existingItemIndex = acc.findIndex(item => item.label === nodo.equipo);
                        if (existingItemIndex !== -1) {
                            acc[existingItemIndex].items.push(nodo);
                        } else {
                            acc.push({ label: nodo.equipo, items: [nodo] });
                        }
                        return acc;
                    }, []);
                    setGroupedZones(zonesGrouped);
                }
            });
        }

        return [
            ...additionalButtons,
            {
                buttonModel: (dialogState?.type) ? {
                    cssClass: "e-danger other",
                    size: "lg",
                    isPrimary: false,
                    content: t("graficador.remove"),
                } : null,
                click: () => {
                    if (dialogState?.type) {

                        const endpoint = `/external/${farmId}/disable-provider`;
                        const body = {
                            externalProviderId: dialogState?.external_provider_id
                        };
                        RestAPI.post("apiAdminDropControl", endpoint, { body })
                            .then(res => {
                                JSON.parse(JSON.stringify(res));
                                toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                setContador((c) => c + 1);
                                setDialogState((state) => {
                                    return { ...state, visible: false };
                                });
                            })
                            .catch(err => {
                                console.error(err);
                                toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            });
                    }
                }
            }
        ];
    }, [navigate, setContador, setDialogState, farmId, dialogState, ceresFarmInfo, acceso_limitado, t, hasSoilZone, irrigationZonesSelector]);

    return (
        <div id='infoDialog'>
            <DialogComponentWrapper
                dialogState={dialogState}
                containerId="externalInfoDialog"
                setDialogState={setDialogState}
                buttons={buttons}
                width="600px"
                allowDragging={false}
                header={t("external.connection-information")}
            >
                <div className='rowCenter'>
                    <img src={typeToImage[dialogState?.type] ?? CeresImg} width="150px" height="150px" alt='' />
                </div>
                <div className='row linea-formulario'>
                    {ceresDataDdb?.Item?.user_name &&
                        <><div className="col-12 col-md-6 text-md-right">
                            <label className='boldie'>{t("external.userName")}</label>
                        </div>
                        <div className="col-12 col-md-6 text-md-left d-block">
                            {ceresDataDdb?.Item?.user_name}
                        </div></>}
                    {ceresFarmInfo?.flightDate &&
                        <><div className="col-12 col-md-6 text-md-right">
                            <label className='boldie'>{t("external.flight-date")}</label>
                        </div>
                        <div className="col-12 col-md-6 text-md-left d-block">
                            {`${ceresFarmInfo?.flightDate?.slice(0, 10)}`}
                        </div></>}
                    {getStationName(dialogState?.config?.stationId) &&
                        <><div className="col-12 col-md-6 text-md-right">
                            <label className='boldie'>{t("external.station-name")}</label>
                        </div>
                        <div className="col-12 col-md-6 text-md-left d-block">
                            {getStationName(dialogState?.config?.stationId)}
                        </div></>}
                    {
                        dialogState?.nombre_sector ?
                            <>
                                <div className="col-12 col-md-6 text-md-right">
                                    <label className='boldie'>{t("thead.sector")}</label>
                                </div>
                                <div className="col-12 col-md-6 text-md-left d-block">
                                    {dialogState?.nombre_sector}
                                </div>
                            </> : <></>
                    }
                    {
                        dialogState?.config?.device_sn &&
                            <>
                                <div className="col-12 col-md-6 text-md-right">
                                    <label className='boldie'>{t("external.device-serial-number")}</label>
                                </div>
                                <div className="col-12 col-md-6 text-md-left d-block">
                                    {dialogState?.config?.device_sn}
                                </div>
                            </>
                    }

                    {
                        dialogState?.type == "ARABLE" &&
                        <>
                            <div className="col-12 col-md-6 text-md-right">
                                <label className='boldie'>{t("external.device-serial-number")}</label>
                            </div>
                            <div className="col-12 col-md-6 text-md-left d-block">
                                {dialogState?.config?.device_id}
                            </div>
                        </>
                    }
                    <div className="col-12 col-md-6 text-md-right">
                        <label className='boldie'>{t("external.connection-date")}</label>
                    </div>
                    <div className="col-12 col-md-6 text-md-left d-block">
                        {dialogState?.create?.slice(0, 10)}
                    </div>
                    {
                        hasSoilZone &&
                        <>
                            <div className="col-12 col-md-6 text-md-right">
                                <label className='boldie'>{t("external.associatedIrrZone")}</label>
                            </div>
                            <div className="col-12 col-md-6 text-md-left d-block">
                                { dialogState?.config?.sector_id_riego ?
                                    sectorsInfo?.find(sec => sec.sector_id === dialogState.config.sector_id_riego)?.nombre || "-"
                                    :
                                    t("external.noAssociatedZone")}
                            </div>
                        </>
                    }
                </div>
            </DialogComponentWrapper>
            <ZoneAssociationDialog
                dialogState={soilZoneDialogState}
                setDialogState={setSoilZoneDialogState}
                setContador={setContador}
                farmId={farmId}
                groupedZones={groupedZones}
            />
            <DavisLoginDialog
                dialogState={davisLoginState}
                setDialogState={setDavisLoginState}
                setContador={setContador}
                farmId={farmId}
            />
        </div>
    );
};

const UserDialog = ({ dialogState, setDialogState, setContador, dataCheck,setMainDialogState, setFormState }) => {
    const location = useLocation();
    const farmId = getFarm(location);
    const sectorRef = useRef(null);
    const stationNameRef = useRef(null);
    const { t, i18n } = useTranslation();
    const [token, setToken] = useState([]);
    const [dataApi, setDataApi] = useState([]);
    const [forceLoading, setForceLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [validationState, setValidationState] = useState({ msg: "", visible: false });
    const irrimaxFormRef = useRef();
    const davisFormRef = useRef();
    const [{ dataFarm }, _] = useContext(FarmContext);

    let buttons;
    let connected;

    switch (dialogState?.dataTipo) {
        case "ARABLE":
            buttons = [
                {
                    buttonModel: (selectedDate && dialogState?.selected) ? {
                        cssClass: "e-primary",
                        content: t("external.conectar"),
                        isPrimary: true,
                        disabled: false
                    } :  {
                        cssClass: "e-primary",
                        content: t("external.conectar"),
                        isPrimary: true,
                        disabled: true
                    },
                    click: () => {
                        conectar();
                    }
                },
            ];

            dataCheck?.forEach((d) => {
                if (d?.tipo === "ARABLE") {
                    if (d.config.device_id == dialogState?.selected?.id) {
                        connected = true;
                        buttons = [
                            {
                                buttonModel:{
                                    cssClass: "e-primary",
                                    content: t("external.conectar"),
                                    isPrimary: true,
                                    disabled: true
                                }
                            }
                        ];
                    }
                }
            });
            break;
        case "IRRIMAX":
            buttons = [
                {
                    buttonModel: {
                        cssClass: "e-primary",
                        content: t("external.conectar"),
                        isPrimary: true,
                    },
                    click: ({ type }) => {
                        if (type !== "keydown" && irrimaxFormRef) {
                            irrimaxFormRef.current.submitForm();
                        }
                    }
                },
            ];
            break;
        case "DAVIS":
            buttons = [
                {
                    buttonModel: {
                        cssClass: "e-primary",
                        content: t("external.conectar"),
                        isPrimary: true,
                    },
                    click: ({ type }) => {
                        if (type !== "keydown" && davisFormRef) davisFormRef.current.submitForm();
                    }
                },
            ];
            break;

        default:
            buttons = [
                {
                    buttonModel: {
                        cssClass: "e-primary",
                        content: t("external.conectar"),
                        isPrimary: true,
                    },
                    click: () => {
                        conectar();
                    }
                },
            ];
            break;
    }

    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );

    useEffect(() => {
        const getCustomerFarmsField = async () => {
            if (dialogState?.dataToken?.access) {
                setToken(dialogState?.dataToken);
                const customConfig = {
                    headers: {
                        Authorization: `Bearer ${dialogState?.dataToken?.access}`,
                    }
                };
                const { data } = await axios.get("https://works.ceresimaging.net/api/cff/", customConfig);
                setDataApi(data);
            }
        };
        getCustomerFarmsField();
    }, [dialogState?.dataToken?.access]);


    const conectar = async (body) => {
        if (dialogState.dataTipo === "CERES" && dialogState?.selected?.future_id) {

            if (dataApi?.farms?.length !== 0) {
                const endpoint = `/external/${farmId}`;
                const body = {
                    tipo: dialogState?.dataTipo,
                    farms:
                        [
                            {
                                "campo_id": parseInt(farmId, 10),
                                "ceres_id": dialogState?.selected?.future_id,
                                "customerCeresId": dialogState?.selected?.customer_id
                            }
                        ],
                    refresh_token: token?.refresh,
                    user_name: dialogState?.dataUser
                };
                RestAPI.post("apiAdminDropControl", endpoint, { body })
                    .then(res => {
                        JSON.parse(JSON.stringify(res));
                        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        setContador((contador) => contador + 1);
                        setDataApi([]);
                        setToken([]);
                        setDialogState((state) => {
                            return { ...state, visible: false };
                        });
                        setFormState({visible:false});
                        setMainDialogState({visible:false});
                    })
                    .catch((err) => {
                        if(err?.response?.data?.alreadyConnected){
                            toast.error(t("external.alreadyConnected"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        }else{
                            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        }
                        setDataApi([]);
                        setToken([]);
                        setDialogState((state) => {
                            return { ...state, visible: false };
                        });
                    });
            }
        }
        else if ((dialogState.dataTipo === "UFL" || dialogState.dataTipo === "ZENTRACLOUD")
            && sectorRef.current?.value != undefined && sectorRef.current?.value != "" && sectorRef.current?.value != null) {
            const endpoint = `/external/${farmId}`;
            const body = {
                tipo: dialogState?.dataTipo,
            };
            const sector = sectorRef.current?.value;
            switch (dialogState.dataTipo) {
                case "UFL":
                    body["stationId"] = dialogState.stationId;
                    body["nodeName"] = "UFL - " + getStationName(dialogState.stationId);
                    body["sectorName"] = sector;
                    body["locale"] = i18n.language;
                    break;

                case "ZENTRACLOUD":
                    body["deviceSn"] = dialogState.deviceSn;
                    body["apiToken"] = dialogState.apiToken;
                    body["sectorName"] = sector;
                    body["nodeName"] = "ZentraCloud - " + stationNameRef.current?.value;
                    body["locale"] = i18n.language;
                    break;

                default:
                    break;
            }
            RestAPI.post("apiAdminDropControl", endpoint, { body })
                .then(res => {
                    JSON.parse(JSON.stringify(res));
                    toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setContador((contador) => contador + 1);
                    setDataApi([]);
                    setDialogState((state) => {
                        return { ...state, visible: false };
                    });
                    setMainDialogState({visible:false});
                })
                .catch(err => {
                    console.error(err);
                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setDataApi([]);
                    setDialogState((state) => {
                        return { ...state, visible: false };
                    });
                });
        } else if (dialogState.dataTipo === "ARABLE") {
            const endpoint = `/external/${farmId}`;
            const body = {
                tipo: dialogState?.dataTipo,
                email: dialogState?.dataUser,
                dataToken: dialogState?.dataToken,
                arableApiKey: dialogState?.dataToken?.apiKey,
                arableDeviceId:  dialogState?.selected?.id,
                sectorName: dialogState?.selected?.site,
                nodeName: dialogState?.selected?.displayName,
                from: selectedDate,
                locale: i18n.language,
            };
            RestAPI.post("apiAdminDropControl", endpoint, { body })
                .then(res => {
                    JSON.parse(JSON.stringify(res));
                    toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setContador((contador) => contador + 1);
                    setDataApi([]);
                    setToken([]);
                    setDialogState((state) => {
                        return { ...state, visible: false };
                    });
                    setMainDialogState({visible:false});
                })
                .catch(err => {
                    console.error(err);
                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setDataApi([]);
                    setToken([]);
                    setDialogState((state) => {
                        return { ...state, visible: false };
                    });
                });

        } else if (dialogState.dataTipo === "WEENAT") {
            const endpoint = `/external/${farmId}`;
            const body = {
                tipo: dialogState?.dataTipo,
                token: dialogState?.token,
                plotId:  dialogState?.selectedPlot?.id,
                sectorName: dialogState?.selectedPlot?.name,
                nodeName: dialogState?.selectedPlot?.name,
                locale: i18n.language,
            };
            const errorFound = Object.keys(body).some(key => validateSomething(body[key]));
            if (errorFound) {
                setValidationState({ msg: t("external.not-all-fields"), visible: true });
                return;
            }
            setValidationState({ msg: "", visible: false });

            try {
                await RestAPI.post("apiAdminDropControl", endpoint, { body });
                toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                setContador((contador) => contador + 1);
                setDataApi([]);
                setToken([]);
                setDialogState((state) => {
                    return { ...state, visible: false };
                });
                setMainDialogState({visible:false});
            } catch (error) {
                console.error(error);
                if(error?.response?.data?.plotAlreadyExists){
                    toast.error(t("external.plotaAlreadyExists"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                }else{
                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                }
                setDataApi([]);
                setToken([]);
                setDialogState((state) => {
                    return { ...state, visible: false };
                });

            }
        } else if (dialogState.dataTipo === "IRRIMAX") {
            const endpoint = `/external/${farmId}`;
            RestAPI.post("apiAdminDropControl", endpoint, { body })
                .then(() => {
                    toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setContador((contador) => contador + 1);
                    setMainDialogState({visible:false});
                })
                .catch((err) => {
                    if(err?.response?.data.providerExists){
                        toast.error(t("external.alreadyConnected"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    }else{
                        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    }
                });
            setDataApi([]);
            setToken([]);
            setDialogState((state) => {
                return { ...state, visible: false };
            });
        } else if (dialogState.dataTipo === "DAVIS") {
            const endpoint = `/external/${farmId}`;
            RestAPI.post("apiAdminDropControl", endpoint, { body })
                .then(() => {
                    toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                    setContador((contador) => contador + 1);
                    setMainDialogState({visible:false});
                })
                .catch(() => {
                    toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                });
            setDataApi([]);
            setToken([]);
            setDialogState((state) => {
                return { ...state, visible: false };
            });
        }
    };

    const getPlotSensorsInfo = async (token, plotId) => {
        const endpoint = `/external/${farmId}/weenat-sensors`;
        const body = { token, plotId, locale: i18n.language };
        const data = await RestAPI.post("apiAdminDropControl", endpoint, { body });
        return data;
    };

    const onChangeWeenatPlot = async (value) => {
        try {
            setForceLoading(true);
            const selectedPlot = value;
            const plotSensors = await getPlotSensorsInfo(dialogState?.token, selectedPlot.id);
            setDialogState((state) => {
                return {
                    ...state,
                    selectedPlot,
                    plotSensors
                };
            });
            setValidationState({ msg: "", visible: false });
            setForceLoading(false);
        } catch (error) {
            console.error(error);
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
            setDataApi([]);
            setToken([]);
            setDialogState((state) => {
                return { ...state, visible: false };
            });
        }
    };


    const plotsFromOrg = useMemo(() => {
        const plots = dialogState?.plots;
        const selectedOrgId = dialogState?.selectedOrg?.id;
        if (selectedOrgId && plots) return plots.filter(p => p.organization.id === selectedOrgId);
        return null;
    }, [dialogState?.plots, dialogState?.selectedOrg?.id]);

    const GetForm = (type) => {
        switch (type) {
            case "CERES":
                return (dataApi?.farms ?
                    <><div className='rowCenter'>
                        <h5>{t("external.choose")}</h5>
                    </div>
                    <div className='rowCenter'>
                        <div>
                            <DropdownPrime
                                id='ddlelement'
                                filter={false}
                                value={dialogState.selected}
                                onChange={(e) => {setDialogState((state) => {
                                    return { ...state, selected: e.value };
                                });}}
                                options={dataApi?.farms} optionLabel="name"
                                placeholder={t("external.choose")}
                                showClear={false}
                            />
                        </div>
                    </div></> : <><div className='rowCenter'>
                        <h5>{t("external.empty-farms")}</h5>
                    </div></>);
            case "UFL":
                return (
                    <form id="sectorForm" onSubmit={conectar}>
                        <div className="row linea-formulario">
                            <div className="col-12 col-md-5">
                                <label className="boldie">
                                    {t("external.sector-name")}
                                </label>
                            </div>
                            <div className="mb-2 col-12 col-md-6 d-block">
                                <div className="col-md-10 p-0 unit-input-content">
                                    <input
                                        ref={sectorRef}
                                        name="sector"
                                        placeholder={t("external.sector-name")}
                                        defaultValue={"UFL - " + getStationName(dialogState.stationId)}
                                        className="form-control text-center text-md-left"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                );
            case "ZENTRACLOUD":
                return (
                    <form id="sectorForm" onSubmit={conectar}>
                        <div className="row linea-formulario">
                            <div className="col-12 col-md-5">
                                <label className="boldie">
                                    {t("external.zentracloud-station")}
                                </label>
                                <label className="boldie">
                                    {t("external.sector-name")}
                                </label>
                            </div>
                            <div className="mb-2 col-12 col-md-6 d-block">
                                <div className="">
                                    <input
                                        ref={stationNameRef}
                                        name="station"
                                        placeholder={t("external.zentracloud-station-name")}
                                        defaultValue={t("external.zentracloud-station")}
                                        className="form-control text-center text-md-left"
                                        type="text"
                                    />

                                    <input
                                        ref={sectorRef}
                                        name="sector"
                                        placeholder={t("external.sector-name")}
                                        defaultValue={t("external.zentracloud-zone")}
                                        className="form-control text-center text-md-left mt-1"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                );
            case "ARABLE": {
                const devices = dialogState?.dataToken?.devices;

                const today = new Date();
                const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                const sixMonthsAgo = new Date();
                sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

                const lastSync = dialogState?.selected?.lastSyncDate;

                return (
                    <>
                        <div className='text-center'>
                            <h5>{t("thead.device")}</h5>
                        </div>
                        <div className='mt-2 mb-2'>
                            {dialogState?.dataToken?.devices &&
                                <DropdownPrime
                                    id='ddlelement'
                                    filter={false}
                                    value={dialogState.selected}
                                    onChange={(e) => {setDialogState((state) => {
                                        return { ...state, selected: e.value };
                                    });}}
                                    options={devices} optionLabel="site"
                                    placeholder={t("external.device")}
                                    showClear={false}
                                />}
                        </div>
                        <div className='mt-2 mb-2'>
                            <CalendarPrime
                                t={t}
                                minDate={sixMonthsAgo}
                                maxDate={maxDate}
                                value={selectedDate}  onChange={(e) => setSelectedDate(e.value)}
                                locale={i18n.language}
                                placeholder={t("forms.formatoFecha")}
                                style={{width:"100%"}}
                            />
                        </div>
                        <div className="row linea-formulario">
                            {dialogState?.selected &&
                                <>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className='boldie'>{t("external.statusConnection")}</label>
                                    </div>
                                    <div className="col-12 col-md-6 text-md-left d-block">
                                        <label className="">{t(`external.status.${dialogState?.selected?.state}`)}</label>
                                    </div>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className='boldie'>{t("external.connection")}</label>

                                    </div>
                                    <div className="col-12 col-md-6 text-md-rigth">
                                        <label className="">{lastSync === "" || lastSync === null ? null : dateFormat(lastSync, t, i18n.language, null, false, true)}</label>
                                    </div>
                                </>}
                        </div>
                        <div className="row linea-formulario">
                            {selectedDate ?
                                <></>
                                :
                                <div className="col-12 col-md-12 text-md-rigth">
                                    <label className=''>
                                        <FontAwesomeIcon size="sm" style={{ color: "orange" }} icon={faExclamationTriangle} /> {t("daterangepicker.fecha")}
                                    </label>
                                </div>}
                            {dialogState?.selected ?
                                <></>
                                :
                                <div className="col-12 col-md-12 text-md-rigth">
                                    <label className=''>
                                        <FontAwesomeIcon size="sm" style={{ color: "orange" }} icon={faExclamationTriangle} /> {t("external.device")}
                                    </label>
                                </div>}
                            {connected ?
                                <div className="col-12 col-md-12">
                                    <label className=''>
                                        <FontAwesomeIcon size="sm" style={{ color: "orange" }} icon={faExclamationTriangle} /> {t("external.deviceConnection")}
                                    </label>
                                </div>
                                :
                                <></>}
                        </div>
                    </>
                );
            }
            case "WEENAT":
                return (
                    <div id="extFormContent" >
                        {forceLoading && <LoadingDialog appendTo="self" /> }
                        <div className='col-12 col-md-12'>
                            <label className="boldie text-left">
                                {t("external.selectOrganization")}
                            </label>
                        </div>
                        <div className='mb-2 col-12 col-md-12 d-block'>
                            {dialogState?.organizations &&
                                <DropdownPrime
                                    id='ddlorg'
                                    filter={false}
                                    value={dialogState.selected}
                                    onChange={(e) =>
                                        setDialogState((state) => {
                                            return {
                                                ...state,
                                                selectedOrg: e?.value,
                                                selectedPlot: null,
                                                plotSensors: null
                                            };
                                        })}
                                    options={dialogState?.organizations} optionLabel="name"
                                    placeholder={t("external.organization")}
                                    showClear={false}
                                />}
                        </div>
                        <div className="row linea-formulario" />
                        {
                            dialogState?.selectedOrg &&
                            <>
                                <div className='col-12 col-md-12'>
                                    <label className="boldie text-left">
                                        {t("external.selectPlot")}
                                    </label>
                                </div>
                                <div className='mb-2 col-12 col-md-12 d-block'>
                                    {plotsFromOrg &&
                                        <DropdownPrime
                                            id='ddlplot'
                                            filter={false}
                                            value={dialogState.selectedPlot}
                                            onChange={(e) =>
                                                onChangeWeenatPlot(e?.value)}
                                            options={plotsFromOrg} optionLabel="name"
                                            placeholder={t("external.plot")}
                                            showClear={false}
                                        />}
                                </div>
                            </>
                        }
                        {
                            dialogState?.selectedPlot && dialogState?.plotSensors &&
                            <>
                                <div className="row linea-formulario" />
                                <div className='col-12 col-md-12'>
                                    <label className="boldie text-left">
                                        {t("external.availableSensors")}
                                    </label>
                                </div>
                                <div className='mb-2 col-12 col-md-12 d-block'>
                                    <ul>
                                        {!dialogState.plotSensors.length && <li>No sensors</li>}
                                        {
                                            dialogState.plotSensors.map((sensor, id) => {
                                                let text = sensor.tipo;
                                                if (sensor.depths?.length > 0){
                                                    const depthsText = sensor.depths.join(", ");
                                                    text+= ` (${depthsText})`;
                                                }
                                                return <li key={id}> { text } </li>;
                                            })
                                        }
                                    </ul>

                                </div>
                            </>
                        }
                    </div>
                );
            case "IRRIMAX":
                return (
                    <IrrimaxFormikForm
                        innerRef={irrimaxFormRef}
                        dialogState={dialogState}
                        setDialogState={setDialogState}
                        t={t}
                        i18n={i18n}
                        dataFarm={dataFarm}
                        conectar={conectar}
                        setForceLoading={setForceLoading}
                        setMainDialogState={setMainDialogState}
                    />
                );
            case "DAVIS":
                return (
                    <DavisFormikForm
                        innerRef={davisFormRef}
                        dialogState={dialogState}
                        setDialogState={setDialogState}
                        t={t}
                        i18n={i18n}
                        conectar={conectar}
                    />
                );
            default:
                break;
        }
    };
    if(!dialogState.visible || dialogState.step!==STEP_USER) return null;
    return (
        <div id='userDialog'>
            {dataApi?.length === 0 && token?.access ? <LoadingDialog /> :
                <div>
                    <Dialog
                        className='dialog-prime'
                        visible={dialogState.visible && dialogState.step===STEP_USER}
                        closable
                        draggable={false}
                        style={{width:"400px"}}
                        baseZIndex={1040}
                        footer={footerContent}
                        onHide={() => setDialogState({visible:false, step:STEP_CONNECT})}
                        header={t("external.header-external-provider")}
                    >
                        <div>
                            {GetForm(dialogState.dataTipo)}
                            {
                                validationState?.visible &&
                                    <div className="col-12 msgRawValidation">
                                        <span>{validationState?.msg}</span>
                                    </div>
                            }
                        </div>
                    </Dialog>
                </div>}
        </div>
    );
};

const getStationName = (stationId) => {
    return Object.keys(stationsLookup).find(key => stationsLookup[key] === stationId);
};

const ZoneAssociationDialog = ({ dialogState, setDialogState, setContador, farmId, groupedZones }) => {
    const { t } = useTranslation();
    const [forceLoading, setForceLoading] = useState(false);

    const buttons = useMemo(() => {
        return [
            {
                buttonModel:{
                    cssClass: "e-primary",
                    isPrimary: true,
                    content: t("forms.save"),
                },
                click: async () => {
                    const selectedIrrZoneId = dialogState?.currentIrrZoneId;
                    if (!selectedIrrZoneId) return;

                    const endpoint = `/external/${farmId}/set-irrigation-zone`;
                    const body = {
                        sector_id: dialogState?.providerZoneId,
                        sector_id_riego: selectedIrrZoneId,
                        external_provider_id: dialogState?.providerId
                    };
                    try {
                        setForceLoading(true);
                        await RestAPI.post("apiAdminDropControl", endpoint, { body });
                        toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                        // just force to fetch external providers
                        setContador(c => c + 1);
                    } catch (error) {
                        console.log(error);
                        toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });

                    }
                    setDialogState({ visible: false });
                    setForceLoading(false);
                }
            },
            {
                buttonModel:{
                    cssClass: "e-flat",
                    content: t("forms.cancel"),
                },
                click: () => {
                    setDialogState({ visible: false });
                }
            }
        ];
    }, [t, dialogState?.currentIrrZoneId, dialogState?.providerZoneId, farmId, setDialogState, setContador]);

    const footerContent = (
        <div>
            <Divider />
            {buttons?.map((b) => {
                return (
                    <ButtonPrime key={b?.buttonModel?.content} label={b?.buttonModel?.content} onClick={b?.click} className={`dialog-button dbtn-${b?.buttonModel?.cssClass} ${b?.buttonModel?.isPrimary?"dbtn-primary":""}`} disabled={b?.buttonModel?.disabled} />
                );
            })}
        </div>
    );
    return (
        <div id='zoneDialog'>
            <Dialog
                className='dialog-prime'
                visible={dialogState.visible}
                closable
                draggable={false}
                style={{width:"400px"}}
                baseZIndex={1040}
                footer={footerContent}
                onHide={() => {
                    setDialogState({visible:false});}}
                header={t("external.associateIrrigation")}
            >
                <div id="containerZoneDialog" >
                    {forceLoading && <LoadingDialog appendTo="self" />}
                    <div className='rowH5'>
                        <h5>{t("external.associatedIrrZone")}</h5>
                    </div>
                    <div className='rowH5'>
                        <div>
                            { dialogState?.irrigationZones &&
                            <DropdownPrime
                                value={dialogState?.currentIrrZoneId}
                                onChange={(e) => {
                                    setDialogState((state) => {
                                        return {
                                            ...state,
                                            currentIrrZoneId: e?.value
                                        };
                                    });
                                }}
                                options={groupedZones} optionLabel="nombre"
                                optionGroupChildren="items" optionGroupLabel="label" optionValue="sector_id"
                                placeholder={t("external.associatedIrrZone")}
                                showClear={false}
                                filter={dialogState?.irrigationZones?.length > 10}
                            />}
                        </div>
                    </div>
                </div>
            </Dialog>

        </div>
    );
};


export { ConnectDialog, InfoDialog };
